import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Product extends Form {

    constructor(data = {}) {
        super(data);

        this.products = false;
        this.selected = false;
    }

    productsAvailable() {
        if (this.products && this.products.data) {
            return this.products.data.length > 0;
        }

        return false;
    }

    index() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/product', self.data)
                .then(response => {

                    this.products = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    all(currency = null) {
        let self = this;
        let uri = '/api/product/all';

        if (currency) {
            uri = uri + '?c=' + currency;
        }

        return new Promise((resolve, reject) => {
            axios.get(uri, self.data)
                .then(response => {

                    this.products = response.data;

                    resolve(this.products);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    list(currency = null, account = null) {
        let self = this;
        let uri = '/api/product/list';

        if (currency) {
            uri = uri + '?c=' + currency;
        }
        if (account) {
            uri = uri + '?a=' + account;
        }

        return new Promise((resolve, reject) => {
            axios.get(uri, self.data)
                .then(response => {

                    this.products = response.data;

                    resolve(this.products);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    search(query = null) {
        let self = this;
        let uri = '/api/product/search';

        if (query) {
            uri = uri + '?q=' + query;
        }

        return new Promise((resolve, reject) => {
            axios.get(uri, self.data)
                .then(response => {

                    this.products = response.data;

                    resolve(this.products);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    deleteProduct(sku) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.delete('/api/product/' + sku, self.data)
                .then(response => {
                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

}
